import { createFileRoute } from "@tanstack/react-router";
import { SignIn } from "@/features/auth/sign-in";
import { isAppPath, savePostAuthRedirect } from "@/lib/post-auth-redirect";

export const Route = createFileRoute("/(auth)/sign-in")({
  // The param (not just the stash) carries the target into the real browser
  // when the auth form escapes an in-app browser by reopening this URL.
  validateSearch: (search: Record<string, unknown>): { redirect?: string } => ({
    redirect: isAppPath(search.redirect) ? search.redirect : undefined,
  }),
  beforeLoad: ({ search }) => {
    if (search.redirect) savePostAuthRedirect(search.redirect);
  },
  component: SignIn,
});
